/**
 * Consulta endereço a partir de um CEP via API pública ViaCEP.
 * Não requer proxy — CORS aberto. Falhas silenciosas (offline, CEP inválido).
 *
 * @param {string} cep - CEP com ou sem hífen (ex: "01234-567" ou "01234567")
 * @returns {Promise<{street: string, neighborhood: string, city: string, state: string}|null>}
 */
export async function lookupCep(cep) {
  const clean = cep.replace(/\D/g, '');
  if (clean.length !== 8) return null;

  try {
    const res = await fetch(`https://viacep.com.br/ws/${clean}/json/`);
    if (!res.ok) return null;
    const data = await res.json();
    if (data.erro) return null;
    return {
      street: data.logradouro || '',
      neighborhood: data.bairro || '',
      city: data.localidade || '',
      state: data.uf || '',
    };
  } catch {
    return null;
  }
}
